import {ColumnMain} from "#/models/column-main";
import {Column} from "#/models/column";
import {Trans} from "@lingui/macro";
import {Tag} from "antd";
import React from "react";

const SaleModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();
    
    columns.push({key:'invoiceNo', width: 150, filter:true, sorter:true, title:<Trans>Invoice No</Trans>});
    columns.push({key:'item.itemNo', dataIndex: ['item', 'itemNo'], width: 150, filter:true, sorter:true, title:<Trans>MSC Part Number</Trans>});
    columns.push({key:'item.name', dataIndex: ['item', 'name'],width: 200, filter:true, sorter:true, title:<Trans>Item Name</Trans>});
    columns.push({key:'quantity', width: 120, filter:true, sorter:true, title:<Trans>Quantity</Trans>});
    columns.push({key:'source', width: 150, filter:true, sorter:true, title:<Trans>Source</Trans>});
    
    columns.push({
        key:'isMemberDistribute', 
        width: 150,
        checkboxFilter:true,
        filter:true, 
        sorter:true, 
        title:<Trans>Is Member Distribute</Trans>,
        render: (value: boolean) => (
            <Tag color={value ? 'green' : 'red'}>
                {value ? <Trans>Yes</Trans> : <Trans>No</Trans>}
            </Tag>
        )
    });
    
    columns.push({key:'updatedDate', width: 150, dateTimeFilter:true, sorter:true, title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 200, filter:true, sorter:true, title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 150, dateTimeFilter:true, sorter:true, title:<Trans>Created Date</Trans>, direction:"desc"});
    columns.push({key:'createdBy', width: 200, filter:true, sorter:true, title:<Trans>Created By</Trans>});

    return{
        columns:columns,
        url:"/resource/sales"
    };
}
export default SaleModel();
